/**
 * Extrai cookies primários (_fbp, _fbc, _ga, _gcl_au) do navegador.
 */
export function getTrackingCookies() {
  if (typeof document === 'undefined') return {};

  const cookies = document.cookie.split(';').reduce(
    (acc, c) => {
      const [key, val] = c.trim().split('=');
      acc[key] = decodeURIComponent(val || '');
      return acc;
    },
    {} as Record<string, string>
  );

  const _fbp = cookies['_fbp'] || null;
  const _fbc =
    cookies['_fbc'] ||
    (() => {
      // Extra fallback: tentar extrair do URL (caso o usuário veio de um anúncio)
      const fbclid = new URLSearchParams(window.location.search).get('fbclid');
      return fbclid ? `fb.1.${Date.now()}.${fbclid}` : null;
    })();

  const _ga = cookies['_ga'] || null;
  const _gcl_au = cookies['_gcl_au'] || null;

  return { _fbp, _fbc, _ga, _gcl_au };
}
